import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { ApiService } from "../../ApiService";

import { TextField, Button, CircularProgress, Skeleton, Typography } from "@mui/material";

import glass from "../../../images/mag-glass.png";
import gear from "../../../images/settings.png";
import work from "../../../images/working.jpg";
import verify from "../../../images/verify.png";

export const VisitasSeguridadEdit = ({ companyData, currentBranch }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isDataLoading, setIsDataLoading] = useState(true);
	const [desktopCards, setDesktopCards] = useState([
		{
			icon: glass,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
		{
			icon: gear,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
		{
			icon: verify,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
	]);

	const [mobileCards, setMobileCards] = useState([
		{
			icon: glass,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
		{
			icon: gear,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
		{
			icon: verify,
			title: "",
			titleOriginal: "",
			text: "",
			textOriginal: "",
			editingTitle: false,
			editingText: false,
		},
	]);

	useEffect(() => {
		if (companyData && companyData.view_segurity) {
			setIsDataLoading(true);
			const updatedDesktopCards = [...desktopCards];
			const updatedMobileCards = [...mobileCards];

			companyData.view_segurity.forEach((item, index) => {
				if (index < updatedDesktopCards.length) {
					updatedDesktopCards[index].title = item.title || "";
					updatedDesktopCards[index].titleOriginal = item.title || "";
					updatedDesktopCards[index].text = item.text || "";
					updatedDesktopCards[index].textOriginal = item.text || "";

					updatedMobileCards[index].title = item.title || "";
					updatedMobileCards[index].titleOriginal = item.title || "";
					updatedMobileCards[index].text = item.text || "";
					updatedMobileCards[index].textOriginal = item.text || "";
				}
			});
			setDesktopCards(updatedDesktopCards);
			setMobileCards(updatedMobileCards);
			setIsDataLoading(false);
		}
	}, [companyData]);
	const activateDesktopTitleEdit = (index) => {
		const updatedCards = [...desktopCards];
		updatedCards.forEach((card) => {
			card.editingTitle = false;
			card.editingText = false;
		});
		updatedCards[index].editingTitle = true;
		setDesktopCards(updatedCards);
	};

	const handleDesktopTitleChange = (e, index) => {
		if (e.target.value.length <= 35) {
			const updatedCards = [...desktopCards];
			updatedCards[index].title = e.target.value;
			setDesktopCards(updatedCards);
		}
	};

	const cancelDesktopTitleEdit = (index) => {
		const updatedCards = [...desktopCards];
		updatedCards[index].title = updatedCards[index].titleOriginal;
		updatedCards[index].editingTitle = false;
		setDesktopCards(updatedCards);
	};

	const saveDesktopTitle = async (index) => {
		if (!currentBranch) return;
		const updatedCards = [...desktopCards];
		const newTitle = updatedCards[index].title;
		if (!newTitle.trim()) {
			toast.error("El título no puede quedar vacío.");
			return;
		}
		setIsLoading(true);
		const updatedData = {
			view_segurity: desktopCards.map((_, i) => {
				if (i === index) {
					return {
						title: newTitle.trim(),
						text: desktopCards[index].textOriginal,
					};
				}
				return {};
			}),
		};
		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};
			const response = await ApiService.fetchData(url, payload);
			if (response?.code === 200) {
				updatedCards[index].titleOriginal = newTitle.trim();
				updatedCards[index].editingTitle = false;
				setDesktopCards(updatedCards);
				const updatedMobileCards = [...mobileCards];
				updatedMobileCards[index].title = newTitle.trim();
				updatedMobileCards[index].titleOriginal = newTitle.trim();
				setMobileCards(updatedMobileCards);
				toast.success(response.message || "Título actualizado correctamente.");
			} else {
				toast.error(response?.message || "Error al actualizar el título.");
				updatedCards[index].title = updatedCards[index].titleOriginal;
				setDesktopCards(updatedCards);
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el título.");
			updatedCards[index].title = updatedCards[index].titleOriginal;
			setDesktopCards(updatedCards);
		} finally {
			setIsLoading(false);
		}
	};

	// Desktop text editing
	const activateDesktopTextEdit = (index) => {
		const updatedCards = [...desktopCards];

		// Close all other editing fields
		updatedCards.forEach((card) => {
			card.editingTitle = false;
			card.editingText = false;
		});

		updatedCards[index].editingText = true;
		setDesktopCards(updatedCards);
	};

	const handleDesktopTextChange = (e, index) => {
		if (e.target.value.length <= 135) {
			const updatedCards = [...desktopCards];
			updatedCards[index].text = e.target.value;
			setDesktopCards(updatedCards);
		}
	};

	const cancelDesktopTextEdit = (index) => {
		const updatedCards = [...desktopCards];
		updatedCards[index].text = updatedCards[index].textOriginal;
		updatedCards[index].editingText = false;
		setDesktopCards(updatedCards);
	};

	const saveDesktopText = async (index) => {
		if (!currentBranch) return;

		const updatedCards = [...desktopCards];
		const newText = updatedCards[index].text;

		if (!newText.trim()) {
			toast.error("El texto no puede quedar vacío.");
			return;
		}

		setIsLoading(true);

		const updatedData = {
			view_segurity: desktopCards.map((_, i) => {
				if (i === index) {
					return {
						title: desktopCards[index].titleOriginal,
						text: newText.trim(),
					};
				}
				return {};
			}),
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				// Update desktop state
				updatedCards[index].textOriginal = newText.trim();
				updatedCards[index].editingText = false;
				setDesktopCards(updatedCards);

				// Update mobile state to match
				const updatedMobileCards = [...mobileCards];
				updatedMobileCards[index].text = newText.trim();
				updatedMobileCards[index].textOriginal = newText.trim();
				setMobileCards(updatedMobileCards);

				toast.success(response.message || "Texto actualizado correctamente.");
			} else {
				toast.error(response?.message || "Error al actualizar el texto.");
				// Revert to original
				updatedCards[index].text = updatedCards[index].textOriginal;
				setDesktopCards(updatedCards);
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el texto.");
			// Revert to original
			updatedCards[index].text = updatedCards[index].textOriginal;
			setDesktopCards(updatedCards);
		} finally {
			setIsLoading(false);
		}
	};

	// Mobile title editing
	const activateMobileTitleEdit = (index) => {
		const updatedCards = [...mobileCards];

		// Close all other editing fields
		updatedCards.forEach((card) => {
			card.editingTitle = false;
			card.editingText = false;
		});

		updatedCards[index].editingTitle = true;
		setMobileCards(updatedCards);
	};

	const handleMobileTitleChange = (e, index) => {
		if (e.target.value.length <= 35) {
			const updatedCards = [...mobileCards];
			updatedCards[index].title = e.target.value;
			setMobileCards(updatedCards);
		}
	};

	const cancelMobileTitleEdit = (index) => {
		const updatedCards = [...mobileCards];
		updatedCards[index].title = updatedCards[index].titleOriginal;
		updatedCards[index].editingTitle = false;
		setMobileCards(updatedCards);
	};

	const saveMobileTitle = async (index) => {
		if (!currentBranch) return;

		const updatedCards = [...mobileCards];
		const newTitle = updatedCards[index].title;

		if (!newTitle.trim()) {
			toast.error("El título no puede quedar vacío.");
			return;
		}

		setIsLoading(true);

		const updatedData = {
			view_segurity: mobileCards.map((_, i) => {
				if (i === index) {
					return {
						title: newTitle.trim(),
						text: mobileCards[index].textOriginal,
					};
				}
				return {};
			}),
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};
			const response = await ApiService.fetchData(url, payload);
			if (response?.code === 200) {
				updatedCards[index].titleOriginal = newTitle.trim();
				updatedCards[index].editingTitle = false;
				setMobileCards(updatedCards);
				const updatedDesktopCards = [...desktopCards];
				updatedDesktopCards[index].title = newTitle.trim();
				updatedDesktopCards[index].titleOriginal = newTitle.trim();
				setDesktopCards(updatedDesktopCards);
				toast.success(response.message || "Título actualizado correctamente.");
			} else {
				toast.error(response?.message || "Error al actualizar el título.");
				updatedCards[index].title = updatedCards[index].titleOriginal;
				setMobileCards(updatedCards);
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el título.");
			updatedCards[index].title = updatedCards[index].titleOriginal;
			setMobileCards(updatedCards);
		} finally {
			setIsLoading(false);
		}
	};

	// Mobile text editing
	const activateMobileTextEdit = (index) => {
		const updatedCards = [...mobileCards];
		updatedCards.forEach((card) => {
			card.editingTitle = false;
			card.editingText = false;
		});

		updatedCards[index].editingText = true;
		setMobileCards(updatedCards);
	};

	const handleMobileTextChange = (e, index) => {
		if (e.target.value.length <= 135) {
			const updatedCards = [...mobileCards];
			updatedCards[index].text = e.target.value;
			setMobileCards(updatedCards);
		}
	};
	const cancelMobileTextEdit = (index) => {
		const updatedCards = [...mobileCards];
		updatedCards[index].text = updatedCards[index].textOriginal;
		updatedCards[index].editingText = false;
		setMobileCards(updatedCards);
	};

	const saveMobileText = async (index) => {
		if (!currentBranch) return;

		const updatedCards = [...mobileCards];
		const newText = updatedCards[index].text;

		if (!newText.trim()) {
			toast.error("El texto no puede quedar vacío.");
			return;
		}

		setIsLoading(true);

		const updatedData = {
			view_segurity: mobileCards.map((_, i) => {
				if (i === index) {
					return {
						title: mobileCards[index].titleOriginal,
						text: newText.trim(),
					};
				}
				return {};
			}),
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				updatedCards[index].textOriginal = newText.trim();
				updatedCards[index].editingText = false;
				setMobileCards(updatedCards);

				const updatedDesktopCards = [...desktopCards];
				updatedDesktopCards[index].text = newText.trim();
				updatedDesktopCards[index].textOriginal = newText.trim();
				setDesktopCards(updatedDesktopCards);
				toast.success(response.message || "Texto actualizado correctamente.");
			} else {
				toast.error(response?.message || "Error al actualizar el texto.");
				updatedCards[index].text = updatedCards[index].textOriginal;
				setMobileCards(updatedCards);
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el texto.");
			updatedCards[index].text = updatedCards[index].textOriginal;
			setMobileCards(updatedCards);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div>
			<div className="seguridad-container">
				<div className="header-area">
					<div className="header-area">
						<h1>
							Sistema de <span style={{color:'var(--theme-company)'}}>seguridad de</span> nuestro Producto
						</h1>
					</div>
				</div>
				<div className="left-area"></div>
				<div className="right-area"></div>
				<div className="pill-container">
					<div className="pill-interior">
						<div className="pill-content">
							<img src={work} className="pill-image" alt="" />
						</div>
					</div>
				</div>

				<div className="features">
					{isDataLoading ? (
						<>
							{[0, 1, 2].map((index) => (
								<div className="feature-card" key={index}>
									<Skeleton variant="circular" width={80} height={80} />
									<Skeleton variant="text" width="80%" height={30} />
									<Skeleton variant="text" width="100%" height={60} />
								</div>
							))}
						</>
					) : (
						desktopCards.map((card, index) => (
							<div className="feature-card" key={index}>
								<div className={index === 0 ? "feature-icon" : "feature-icon-white"}>
									<div className="icon-container-class">
										<img
											src={card.icon}
											className={index === 2 ? "image-verification" : "image"}
											alt=""
										/>
									</div>
								</div>

								{/* Title */}
								{card.editingTitle ? (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											gap: 8,
											zIndex: 3,
										}}>
										<TextField
											variant="outlined"
											size="small"
											value={card.title}
											onChange={(e) => handleDesktopTitleChange(e, index)}
											disabled={isLoading}
											sx={{
												"& input": {
													textAlign: "center",
													fontWeight: 600,
													color: index !== 0 ? "#fff" : "inherit",
													border: index !== 0 ? "1px solid #fff" : "inherit",
												},
											}}
										/>
										<Typography
											variant="caption"
											sx={{
												display: "block",
												textAlign: "right",
												color:
													card.title.length >= 28
														? card.title.length >= 35
															? "error.main"
															: "warning.main"
														: "#fff",
												mt: 0.5,
												mb: 1,
											}}>
											{card.title.length}/35 caracteres
										</Typography>
										<div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
											<Button
												sx={{ backgroundColor: "#fff" }}
												variant="outlined"
												onClick={() => cancelDesktopTitleEdit(index)}
												disabled={isLoading}>
												Cancelar
											</Button>
											<Button
												variant="contained"
												onClick={() => saveDesktopTitle(index)}
												disabled={isLoading}
												startIcon={isLoading ? <CircularProgress size={20} /> : null}>
												{isLoading ? "Guardando..." : "Guardar"}
											</Button>
										</div>
									</div>
								) : (
									<h2
										className="feature-title"
										style={{ position: "relative", top: "7px", cursor: "pointer" }}
										onClick={() => activateDesktopTitleEdit(index)}>
										{card.title}
									</h2>
								)}

								{/* Description */}
								{card.editingText ? (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											gap: 8,
											position: "relative",
											top: "20px",
										}}>
										<TextField
											multiline
											variant="outlined"
											size="small"
											value={card.text}
											onChange={(e) => handleDesktopTextChange(e, index)}
											disabled={isLoading}
											sx={{
												"width": "300px",
												"& .MuiOutlinedInput-root": {
													"color": "#fff",
													"& fieldset": {
														borderColor: "#fff",
													},
													"&:hover fieldset": {
														borderColor: "#fff",
													},
													"&.Mui-focused fieldset": {
														borderColor: "#fff",
													},
												},
												"& textarea": {
													color: "#fff",
												},
											}}
										/>
										<Typography
											variant="caption"
											sx={{
												display: "block",
												textAlign: "right",
												color:
													card.text.length >= 115
														? card.text.length >= 135
															? "error.main"
															: "warning.main"
														: "#fff",
												mt: 0.5,
												mb: 1,
											}}>
											{card.text.length}/135 caracteres
										</Typography>
										<div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
											<Button
												sx={{ backgroundColor: "#fff" }}
												variant="outlined"
												onClick={() => cancelDesktopTextEdit(index)}
												disabled={isLoading}>
												Cancelar
											</Button>
											<Button
												variant="contained"
												onClick={() => saveDesktopText(index)}
												disabled={isLoading}
												startIcon={isLoading ? <CircularProgress size={20} /> : null}>
												{isLoading ? "Guardando..." : "Guardar"}
											</Button>
										</div>
									</div>
								) : (
									<p
										className="feature-description"
										style={{ position: "relative", top: "7px", cursor: "pointer" }}
										onClick={() => activateDesktopTextEdit(index)}>
										{card.text}
									</p>
								)}
							</div>
						))
					)}
				</div>
			</div>

			{/* MOBILE VERSION */}
			<div className="mobile-seguridad-container">
				<h1 className="mobile-security-title">
					Sistema de <span>seguridad de</span> nuestro Producto
				</h1>

				<div className="mobile-security-cards">
					{isDataLoading ? (
						<>
							{[0, 1, 2].map((index) => (
								<div className="mobile-security-card" key={index}>
									<Skeleton variant="circular" width={60} height={60} />
									<div className="security-content">
										<Skeleton variant="text" width="80%" height={30} />
										<Skeleton variant="text" width="100%" height={60} />
									</div>
								</div>
							))}
						</>
					) : (
						mobileCards.map((card, index) => (
							<div className="mobile-security-card" key={index}>
								<div className="security-icon-circle">
									<img src={card.icon} alt="security icon" className="security-icon" />
								</div>
								<div className="security-content">
									{/* Title */}
									{card.editingTitle ? (
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<TextField
												variant="outlined"
												size="small"
												value={card.title}
												onChange={(e) => handleMobileTitleChange(e, index)}
												disabled={isLoading}
												sx={{
													"& input": {
														textAlign: "center",
														fontWeight: 600,
													},
												}}
											/>
											<Typography
												variant="caption"
												sx={{
													display: "block",
													textAlign: "right",
													color:
														card.title.length >= 28
															? card.title.length >= 35
																? "error.main"
																: "warning.main"
															: "#fff",
													mt: 0.5,
													mb: 1,
												}}>
												{card.title.length}/35 caracteres
											</Typography>
											<div style={{ display: "flex", gap: 8 }}>
												<Button
													variant="contained"
													onClick={() => saveMobileTitle(index)}
													disabled={isLoading}
													startIcon={isLoading ? <CircularProgress size={20} /> : null}>
													{isLoading ? "..." : "Guardar"}
												</Button>
												<Button
													variant="outlined"
													onClick={() => cancelMobileTitleEdit(index)}
													disabled={isLoading}>
													Cancelar
												</Button>
											</div>
										</div>
									) : (
										<h3
											style={{ cursor: "pointer" }}
											onClick={() => activateMobileTitleEdit(index)}>
											{card.title}
										</h3>
									)}

									{/* Description */}
									{card.editingText ? (
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<TextField
												variant="outlined"
												size="small"
												multiline
												value={card.text}
												onChange={(e) => handleMobileTextChange(e, index)}
												disabled={isLoading}
												sx={{
													"width": "100%",
													"& textarea": {
														textAlign: "left",
													},
												}}
											/>
											<Typography
												variant="caption"
												sx={{
													display: "block",
													textAlign: "right",
													color:
														card.text.length >= 115
															? card.text.length >= 135
																? "error.main"
																: "warning.main"
															: "#fff",
													mt: 0.5,
													mb: 1,
												}}>
												{card.text.length}/135 caracteres
											</Typography>
											<div style={{ display: "flex", gap: 8 }}>
												<Button
													variant="contained"
													onClick={() => saveMobileText(index)}
													disabled={isLoading}
													startIcon={isLoading ? <CircularProgress size={20} /> : null}>
													{isLoading ? "..." : "Guardar"}
												</Button>
												<Button
													variant="outlined"
													onClick={() => cancelMobileTextEdit(index)}
													disabled={isLoading}>
													Cancelar
												</Button>
											</div>
										</div>
									) : (
										<p style={{ cursor: "pointer" }} onClick={() => activateMobileTextEdit(index)}>
											{card.text}
										</p>
									)}
								</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
	);
};
